export default __webpack_public_path__ + "static/media/altramuces.ba861b0a.svg";